module.exports = __webpack_public_path__ + "static/skater-ef875b9ae465c125b801e13fcb5904fa.gif";